import React, { Component, useState } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { isNotEmpty, parseClasses } from '../../lib/ep.js';

import DisabledArea from './DisabledArea';
import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';
import Radiobutton from './Radiobutton';
import Tooltip from './Tooltip';

const RadioGroup = (props)=> {

	const value_selected = (props.model != undefined) ? props.model[props.name] : false;

	const [state,setState] = useState({
		selectedRadio:(props.default != undefined) ? props.default : value_selected,
	});

	const changeOption = (value) => {
		if(props.change_cb != undefined) props.change_cb(value);
		if(props.change != undefined) props.change(props.name,value);
		setState(state=>({...state,selectedRadio:value}));
	}

	if(props.elements.length == 0)return false;
	var classname = props?.classname ?? 'input radio_group';
	classname = parseClasses(classname, props._class, 'radiogroup');

	const disabled = props?.disabled ?? false;
	const _field_styles = props?._field_style ?? {};

	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;

	let field_class = [];
	if(disabled) field_class.push('disabledField');
	if(props._radio_class != undefined) field_class.push(props._radio_class);

	return (
		<div class={'react_field type_radiogroup' + ((props._field_class != undefined) ? ' ' + props._field_class : '')} style={_field_styles}>
			<div class={classname+((has_error) ? ' has_error' : '')}>
				{props.children && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
					>{props.children}</FieldLabel>
				)}

				{props.elements.map((p, i) => {
					const autotranslate = (p.label?.type != undefined && typeof p.label != 'string' && p.label != '') ? false : true;
					const enabled = (p.off == undefined || !p.off) ? true : false;

					return (
						<DisabledArea key={i} disabled={(!enabled) ? true : false} message={p.off_message}>
							<div class={"radio_row"+(!enabled ? ' fields_grouper gui_disabledItem':'')}>
								<Radiobutton
									_class={field_class}
									{...p}
									checked={state.selectedRadio === p.value}
									change={(e) => changeOption(p.value)}
									autotranslate={autotranslate}
								>{p.label}</Radiobutton>
							</div>
						</DisabledArea>
					)
				})}

				{(has_error) && (
					<FieldErrorMessage>{has_error}</FieldErrorMessage>
				)}

				{(isNotEmpty(props,'after_message')) && (
					<div class="gui_after_message">{props.intl.formatMessage({id:props.after_message})}</div>
				)}
			</div>
		</div>
	);
	
}

export default injectIntl(RadioGroup);